
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { SEOLandingLayoutWrapper } from '@/components/layouts/SEOLandingLayoutWrapper';
import { TranslationProvider } from '@/context/translation';
import { createLandingGetServerSideProps, type LandingPageProps, } from '@/helpers/createLandingGetServerSideProps';
import { LANDING_CONSTANTS } from '@/constants/landing';
const AiAgeProgressionLanding = dynamic(async () => await import('@/templates/Landing/seoLandings/ai-age-progression/AiAgeProgression'), {
    loading: LoaderScreen,
});
const index: React.FC<LandingPageProps> = ({ locale, translations, namespace, canonicalUrl, }) => {
    return (<TranslationProvider translations={translations} locale={locale}>
			<SEOLandingLayoutWrapper namespace={namespace} serverLocale={locale} serverTranslations={translations} serverCanonical={canonicalUrl}>
				<AiAgeProgressionLanding />
			</SEOLandingLayoutWrapper>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createLandingGetServerSideProps(LANDING_CONSTANTS.PAGE_AI_AGE_PROGRESSION);

    async function __Next_Translate__getServerSideProps__1a1a20bb1ff__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-age-progression/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb1ff__ as getServerSideProps }
  